import http from "../core/http";
const group = 'customerReports';

export const getCustomerReportRequest = async (data) => {
    return await http.post(`${group}/getReport`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportCustomerReportRequest = async (data) => {
    return await http.post(`${group}/export`, data, { responseType: 'blob' }).then(res => res.data).catch(http.defaultCatch);
}
